export default __webpack_public_path__ + "static/sr_widget_edited-ac412c8181ed04e9b36e85ce5ef09d7f.gif";